export default "__VITE_ASSET__Bxwyipgv__"